var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.825 22.8501V17.8501C10.825 17.1334 10.725 16.4876 10.525 15.9126C10.325 15.3376 9.91667 14.7418 9.3 14.1251L10.975 12.4501C11.125 12.6168 11.3042 12.8293 11.5125 13.0876C11.7208 13.3459 11.8833 13.5751 12 13.7751C12.25 13.4084 12.4958 13.0751 12.7375 12.7751C12.9792 12.4751 13.2417 12.2168 13.525 12.0001C14.6917 11.1834 15.4792 10.2043 15.8875 9.0626C16.2958 7.92093 16.4417 6.7251 16.325 5.4751L14.075 7.7001L12.425 6.0501L17.525 0.975098L22.625 6.0501L20.975 7.7001L18.725 5.4751C18.7583 7.25843 18.55 8.76676 18.1 10.0001C17.65 11.2334 16.6417 12.5084 15.075 13.8251C14.2083 14.5751 13.675 15.2459 13.475 15.8376C13.275 16.4293 13.175 17.1001 13.175 17.8501V22.8501H10.825ZM5.475 8.5751C5.40833 8.29176 5.34583 7.8626 5.2875 7.2876C5.22917 6.7126 5.21667 6.10843 5.25 5.4751L3.05 7.7001L1.375 6.0501L6.475 0.975098L11.55 6.0501L9.9 7.7001L7.675 5.4501C7.625 5.98343 7.60833 6.4626 7.625 6.8876C7.64167 7.3126 7.69167 7.68343 7.775 8.0001L5.475 8.5751ZM7.975 12.9251C7.625 12.6084 7.2625 12.2043 6.8875 11.7126C6.5125 11.2209 6.225 10.7501 6.025 10.3001L8.45 9.6751C8.56667 9.94176 8.7375 10.2293 8.9625 10.5376C9.1875 10.8459 9.4 11.0918 9.6 11.2751L7.975 12.9251Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignx);
export default __webpack_public_path__ + "static/media/assignx.479419bccab73471bf56b0ecf91450fd.svg";
export { ForwardRef as ReactComponent };